import * as Yup from 'yup'; 
import { AutocompleteValues, FieldTypes, IFields, InputModes } from 'models/Form/FieldsModels'
import { isPhoneNumberValid } from 'components/Form/Validations/PhoneNumberValidation'
import { isEmailEqualCustomValidation, isEmailValid } from 'components/Form/Validations/EmailValidation'

export enum MObywatelExtendedInfoFieldsNames {
   Email = "Email",
   ConfirmEmail = "ConfirmEmail",
   PhoneNumber = "PhoneNumber",
}

export const mObywatelExtendedInfoFields: IFields = {
   [MObywatelExtendedInfoFieldsNames.Email]: {
      order: 5,
      name: MObywatelExtendedInfoFieldsNames.Email,
      type: FieldTypes.string,
      label: "Adres e-mail",
      placeholder: "Podaj adres e-mail",
      inputMode: InputModes.email,
      browserAutocomplete: AutocompleteValues.Email,

      visible: true,
      maxLength: 40,
      validation: Yup.string().test(isEmailValid)
   },

   [MObywatelExtendedInfoFieldsNames.ConfirmEmail]: {
      order: 10,
      name: MObywatelExtendedInfoFieldsNames.ConfirmEmail,
      type: FieldTypes.string,
      label: "Potwierdź adres e-mail",
      placeholder: "Potwierdź adres e-mail",
      inputMode: InputModes.email,
      browserAutocomplete: AutocompleteValues.Off,
      isPasteDisabled: true,

      visible: true,
      maxLength: 40,
      validation: isEmailEqualCustomValidation
   },

   [MObywatelExtendedInfoFieldsNames.PhoneNumber]: {
      order: 15,
      name: MObywatelExtendedInfoFieldsNames.PhoneNumber,
      type: FieldTypes.string,
      label: "Nr tel. komórkowego",
      placeholder: "Podaj nr telefonu",
      inputMode: InputModes.numeric,
      browserAutocomplete: AutocompleteValues.Phone,

      visible: true,
      mask: "+48 999-999-999",
      validation: Yup.string().test(isPhoneNumberValid),
   },
}